import {FormControl, FormGroup, Validators} from '@angular/forms';
import { DateValidators } from '../../../../../../shared/validators/date-validators';
import { SharedValidators } from '../../../../../../shared/validators/shared-validators';
import { AnnouncementRecipientDialogValidators } from '../validators/announcement-recipient-dialog.validators';
import { AnnouncementRecipientDialogFormModel } from './announcement-recipient-dialog-form.model';

export class AnnouncementRecipientDialogFormBuilder {
  static createFormGroup(): FormGroup<AnnouncementRecipientDialogFormModel> {
    return new FormGroup<AnnouncementRecipientDialogFormModel>(
      {
        pesel: new FormControl<string | null>(null, [
          SharedValidators.peselValidator(),
        ]),
        firstName: new FormControl<string | null>(null, [
          AnnouncementRecipientDialogValidators.minLength(),
        ]),
        lastName: new FormControl<string | null>(null, [
          AnnouncementRecipientDialogValidators.minLength(),
        ]),
        documentNumber: new FormControl<string | null>(null, [
          AnnouncementRecipientDialogValidators.minLength(),
        ]),
        birthDate: new FormControl<Date | null>(null, [
          DateValidators.notInFuture(),
        ]),
        email: new FormControl<string | null>(null, [
          SharedValidators.emailValidator(),
        ]),
        city: new FormControl(null),
        reason: new FormControl<string | null>(null, [
          Validators.required,
        ]),
      },
      { validators: AnnouncementRecipientDialogValidators.searchCriteria() },
    );
  }
}
